<section class="centered-with-padding py-7">
  <div class="grid grid-cols-1 gap-[13px] desk:grid-cols-2">
    @for (tab of data.tabs; track $index) {
      <a class="drop-shadow-custom rounded-[20px] bg-gray-light px-[23px] py-[15px]" [routerLink]="tab.url">
        <div class="grid grid-cols-[1fr_auto]">
          <div>
            <div class="font-title text-[30px] leading-[28px] tracking-[-0.6px]">{{ tab.name }}</div>
            <div class="mt-1.5 flex">
              <span>{{ "GLOBAL.BUDGET" | translate }}</span>
              <span class="ml-1.5 flex">
                @for (i of tab.costLevel | generateRange; track i) {
                  <app-svg [height]="21" [width]="21" src="assets/icons/badge-price.svg" />
                }
              </span>
            </div>
          </div>
          <div class="flex items-center">
            <app-svg src="assets/icons/caret-right.svg" [width]="7" [height]="21" />
          </div>
        </div>
      </a>
    }
  </div>
</section>
